import { Getter, GetterTree } from "vuex";
import { RootState } from "@/store/types";
import { ActivitesState } from "./types";
import { utils } from "@/util";

export const getActivites: Getter<
    ActivitesState,
    RootState
> = state => state.activites || [];

export const getCurrentActivite: Getter<
    ActivitesState,
    RootState
> = state => state.currentActivite || { id : -1};

export const getTypesActivites: Getter<
    ActivitesState,
    RootState
> = state => state.typesActivites || [];

export const getFiltredActivites: Getter<
    ActivitesState,
    RootState
> = state => state.filtredActivites || [];

export const getDate : Getter<ActivitesState,RootState>
= state => state.currentDate || utils.getCurrentTimeNow().format('YYYY-MM-DD');

export const getIsDateDiff : Getter<ActivitesState,RootState>
= state => state.isDateDiff;

export const getters: GetterTree<ActivitesState, RootState> = {
    getActivites,
    getCurrentActivite,
    getTypesActivites,
    getFiltredActivites,
    getDate,
    getIsDateDiff
};
